import { render, staticRenderFns } from "./ReferralsMade.vue?vue&type=template&id=788de13e"
import script from "./ReferralsMade.vue?vue&type=script&lang=js"
export * from "./ReferralsMade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports